import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { hasPermission } from '../lib/permissions'

interface ProtectedProps {
  feature?: string
  children: React.ReactNode
  /** Where to redirect if not authenticated (default: /login) */
  redirectTo?: string
}

/**
 * Renders children only when:
 *  1. The user is authenticated, AND
 *  2. They have the required `feature` permission (if specified).
 *
 * Redirects to /login if not authenticated, or renders null if no permission.
 * Used both as a route wrapper and inline to hide UI elements.
 */
export default function Protected({ feature, children, redirectTo = '/login' }: ProtectedProps) {
  const { claims, loading } = useAuth()

  if (loading) return null

  if (!claims) return <Navigate to={redirectTo} replace />

  if (feature && !hasPermission(claims, feature)) return null

  return <>{children}</>
}
